import React from 'react';
import ReactDOM from 'react-dom';
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { App } from './bootstrap';
import * as serviceWorker from './serviceWorker';
import authService from './utilities/AuthService';

// Disable FontAwesome auto CSS injection
config.autoAddCss = false

authService.loadAuthModule()

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
